export default {
  user: null,
  stage: null,
  csettings: '',
  snackbar: {
    show: false,
    color: '',
    mode: '',
    text: ''
  },
  isDashboardPermission: false,
  companyUsersList: [],
  companyAdminsList: [],
  sidebarOpen: false,
  stages: [],
  dashboardFilters: {
    filters: {}
  },
  questionScoreFilter: {},
  teamData: [],

  // email templates

  templatesList: null,
  EmailTemplate: null,
  templateCategoryOptions: null,
  activeTemplate: null,

  updateEmployeeFilters: null,
  singleEmpView: false,
  activeEmployee: {},
  employeesList: [],
  activeNavigation: 'dashboard',
  loadingEmployeesList: false,
  updateDashboardFilters: null,
  updateReportFilters: null,
  updateReportData: null,
  userWidth: null,
  appLoading: true,
  // employees bulk action status bar configs
  sessionEmployeesCount: '',
  sessionEmployees: '',
  sessionEmployeesSelected: '',
  nonSessionEmployeesSelected: '',
  selectedEmployeesCount: '',
  selectedEmployees: '',
  isAdhocView: false,
  hideAdhoc: false,
  bulkStatus: {
    show: false, // display the action status bar
    action: '', // type of action
    actionStatus: false, // show loader or check icon
    successCount: 0,
    errorCount: 0,
    assignedTo: ''
  },

  // pagination
  page_offset: 1,
  searchString: '',
  driverData: {},
  driversResponses: {},
  driversHeatmap: {},
  driversDemographic: {},
  updateDriversFilters: null,
  heatmapLoading: false,
  adhocData: {},
  interactionDrivers: {},
  updateStatusSsoUser: '',
  userLogoutSucces: ''
};
